import { createContext, useContext } from 'react';

import { FormInstance } from 'antd/es/form';
import dayjs, { Dayjs } from 'dayjs';

import { INITIAL_SNAPSHOT_DATA_STATUS, SHOP_DATA_TABS_GENERAL_KEY } from './constants';
import { SnapshotDataStatusType } from './types';
import { SNAPSHOT_SELECTOR_SELECTION } from '../../common/Snapshot/editor/constants';
import { CommunityType } from '../../types/communities';
import { CommunityContract } from '../../types/contracts';
import { SnapshotDataType } from '../../types/snapshot';
import { UnitType } from '../../types/unit';
import { UnitSource } from '../../utils/helpers/units';

type ShopDataModalContentType = {
  form?: FormInstance;
  loading: boolean;
  requestLoading: boolean;
  community?: CommunityType;
  unitSource?: UnitSource;
  communityId: number;
  snapshot?: SnapshotDataType;
  date: Dayjs;
  units: UnitType[];
  mode: number;
  dataStatus: SnapshotDataStatusType;
  currentTab: string;
  currentStep: number;
  currentLivingType: any;
  currentContract?: CommunityContract;
  currentData: any;
  disabled?: boolean;
  isCommunityCcrc: boolean;
  setCurrentTab: (value: string) => void;
  setRequestLoading: (value: boolean) => void;
  setCurrentStep: (value: number) => void;
  setCurrentContract: (value: CommunityContract) => void;
  setCurrentData: (value: any) => void;
  validateData: (callbackSuccess: () => void, callbackError: () => void) => void;
  handleNavigation: (key: number) => void;
  handleDataStatusChanged: (value: any) => void;
  handleSubmit: () => void;
};

export const ShopDataModalContext = createContext<ShopDataModalContentType>({
  form: undefined,
  loading: false,
  requestLoading: false,
  mode: SNAPSHOT_SELECTOR_SELECTION.ENTER_NEW_DATA,
  community: undefined,
  unitSource: undefined,
  communityId: -1,
  snapshot: undefined,
  date: dayjs(),
  units: [],
  dataStatus: INITIAL_SNAPSHOT_DATA_STATUS,
  currentTab: SHOP_DATA_TABS_GENERAL_KEY,
  currentStep: 0,
  currentLivingType: undefined,
  currentContract: undefined,
  currentData: undefined,
  disabled: false,
  isCommunityCcrc: false,
  setCurrentTab: () => {
    // Do Nothing
  },
  setCurrentStep: () => {
    // Do Nothing
  },
  setCurrentContract: () => {
    // Do Nothing
  },
  setCurrentData: () => {
    // Do Nothing
  },
  validateData: () => {
    // Does Nothing
  },
  setRequestLoading: () => {
    // Does Nothing
  },
  handleDataStatusChanged: () => {
    // Do Nothing
  },
  handleNavigation: () => {
    // Does Nothing
  },
  handleSubmit: () => {
    // Does Nothing
  },
});

export const useShopDataModalContext = () => useContext(ShopDataModalContext);
